import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import request from 'request-promise-native';

import Modal from 'react-responsive-modal';

import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import TopBar from './components/TopBar';
import Login from './components/Login';
import Register from './components/Register';
import ListDevicesTab from './components/tabs/ListDevicesTab';
import ForgotPassword from "./components/ForgotPassword";
import PasswordReset from "./components/PasswordReset";
import Menu from "./components/Menu";
import ListPartnersTab from "./components/tabs/ListPartnersTab";
import ListFirmwaresTab from "./components/tabs/ListFirmwaresTab";
import ListLicensesTab from "./components/tabs/ListLicensesTab";
import ListAdminsTab from "./components/tabs/ListAdminsTab";
import LoadingModal from "./components/modals/LoadingModal";

class App extends Component {
    constructor() {
        super();
        this.state = {
            resetPassword: false,
            forgotPassword: false,
            register: false,
            login: true,
            loading: false,
            tab: 0
        };

        this.queryDict = {}
        window.location.search.substr(1).split("&").forEach(function(item) {
            this.queryDict[item.split("=")[0]] = item.split("=")[1]
        }.bind(this));
        console.log("Query dict:",this.queryDict);

        if(this.queryDict['page']==='passwordreset'){
            this.state.resetPassword=true;

            window.history.replaceState({},"","/");
            return;
        }

        if(this.queryDict['page']==='register'){
            this.state.register=true;

            window.history.replaceState({},"","/");
            return;
        }

        const access_code = localStorage.getItem("access_code");
        console.log('Stored access code: '+access_code);
        if(access_code!=null) {
            this.state.access_code = access_code;
            this.state.login = false;
            this.state.loading = true;
        }
    }

    turnOffLoading() {
        this.setState({
            loading: false
        })
    }

    logout() {
        this.setState({
            login: true,
            access_code: null,
            tab: 0
        });
        localStorage.removeItem("access_code");
    }

    loggedIn(access_code) {
        this.setState({
            login: false,
            access_code: access_code
        });

        localStorage.setItem("access_code", access_code);
    }

    register() {
        this.setState({
            register: true
        });
    }

    forgotPassword() {
        this.setState({
            forgotPassword: true
        });
    }

    render() {
        if(this.state.resetPassword) {
            return (
                <PasswordReset login={() => this.setState({resetPassword: false})} params={this.queryDict}/>
            );
        }

        if(this.state.forgotPassword) {
            return (
                <ForgotPassword login={() => this.setState({forgotPassword: false})}/>
            );
        }
        if(this.state.register) {
            return (
                <Register params={this.queryDict} login={() => this.setState({register: false})}/>
            );
        }
        if(this.state.login) {
            return (
                <Login onLogin={this.loggedIn.bind(this)} register={this.register.bind(this)} forgotPassword={this.forgotPassword.bind(this)}/>
            );
        }

        return (
            <div>

                <TopBar logout={this.logout.bind(this)}/>

                <Menu pageList={[
                    {
                        title: "Device List",
                        picture: (<i className="mdi mdi-apps"/>),
                        id: 0
                    },
                    {
                        title: "Partners",
                        picture: (<i className="mdi mdi-account"/>),
                        id: 1
                    },
                    {
                        title: "Firmware",
                        picture: (<i className="mdi mdi-folder"/>),
                        id: 2
                    },
                    {
                        title: "Licenses",
                        picture: (<i className="mdi mdi-book"/>),
                        id: 3
                    },
                    {
                        title: "Admins",
                        picture: (<i className="mdi mdi-account-multiple"/>),
                        id: 4
                    }
                ]}
                pageSelected={(tab) => this.setState({tab})}/>


                <ListDevicesTab  access_code={this.state.access_code}
                                 logout={this.logout.bind(this)}
                                 turnOffLoading={this.turnOffLoading.bind(this)}
                                 open={this.state.tab===0}/>

                <ListPartnersTab  access_code={this.state.access_code}
                                  logout={this.logout.bind(this)}
                                  open={this.state.tab===1}/>

                <ListFirmwaresTab  access_code={this.state.access_code}
                                   logout={this.logout.bind(this)}
                                   open={this.state.tab===2}/>

                <ListLicensesTab  access_code={this.state.access_code}
                                  logout={this.logout.bind(this)}
                                  open={this.state.tab===3}/>

                <ListAdminsTab  access_code={this.state.access_code}
                                logout={this.logout.bind(this)}
                                open={this.state.tab===4}/>

            </div>
        );
    }
}

export default App;
